module.exports = "/_next/static/images/thread-212825f119dcd253af866ff2915f0a8a.svg";